import * as CP from './connectionPoints.constants';
import ReducerCreator from '../registerReducer';
import { ConnectionPoint } from '../../models';
import { StoreItem } from '../Store';
import { APPLICATION_DISCONNECTED } from '../application/application.constants';
import { buildStoreItem, copyStoreItem, buildLoadingStoreItem } from '../storeItemBuilder';

const r = new ReducerCreator<ConnectionPoint>()
    .register<ConnectionPoint[]>(CP.CONNECTION_POINTS_LOAD, (state, payload) => {
        return buildLoadingStoreItem();
    })
    .register<ConnectionPoint[]>(CP.CONNECTION_POINTS_LOAD_SUCCESS, (state, payload) => {
        return buildStoreItem(payload);
    })
    .register<string>(CP.CONNECTION_POINT_DELETE_SUCCESS, (state, payload) => {
        const newState = copyStoreItem(state.dictionary);
        delete newState.dictionary[payload];
        return newState;
    })
    .register<ConnectionPoint[]>(CP.CONNECTION_POINT_UPDATE, (state, payload) => {
        return (Object as any).assign({}, state, { isLoading: true });
    })
    .register<ConnectionPoint>(CP.CONNECTION_POINT_UPDATE_SUCCESS, (state, payload) => {
        const newState = copyStoreItem(state.dictionary);
        newState.dictionary[payload.guid] = payload;
        return newState;
    })
    .register<string>(APPLICATION_DISCONNECTED, (state, payload) => {
        const newState = new StoreItem<ConnectionPoint>();
        return newState;
    });

export function connectionPointsReducer(
    state: StoreItem<ConnectionPoint> = new StoreItem<ConnectionPoint>(),
    action: { type: string, payload: any }
) {
    return r.reduce(state, action);
}